import {
	isDesktopBrowser,
	isLinux,
	isMac,
	isWindowsPlatform,
} from 'Environment/launchResource/device';
import { LaunchInCEBMode } from 'Workspace/CitrixEnterpriseBrowser';

export const shouldPromptLaunchInCEBPreference = (
	useCitrixEnterpriseBrowser: LaunchInCEBMode
) => {
	const hasAdminConfiguredToLaunchInCEB =
		useCitrixEnterpriseBrowser === LaunchInCEBMode.Always ||
		useCitrixEnterpriseBrowser === LaunchInCEBMode.WithFallback;
	const isMacOrWindowsOrLinuxPlatform = isMac() || isWindowsPlatform() || isLinux();
	const isMacOrWindowsBrowser = isDesktopBrowser() && isMacOrWindowsOrLinuxPlatform;
	return hasAdminConfiguredToLaunchInCEB && isMacOrWindowsBrowser;
};
